import { render, staticRenderFns } from "./LoanApplicationFlow.vue?vue&type=template&id=b0845e46&scoped=true&"
import script from "./LoanApplicationFlow.vue?vue&type=script&lang=js&"
export * from "./LoanApplicationFlow.vue?vue&type=script&lang=js&"
import style0 from "./LoanApplicationFlow.vue?vue&type=style&index=0&id=b0845e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0845e46",
  null
  
)

export default component.exports